export default __webpack_public_path__ + "static/media/6.c9a38279.jpg";